export enum LogLevel {
	DEBUG = 0, ERROR = 1, INFO = 2, TRACE = 3, WARN = 4
}

export class LogEntry {
	constructor(
		public url: string,
		public level: LogLevel,
		public error: string
	) {}
}
